import { render, staticRenderFns } from "./product-detail.vue?vue&type=template&id=27bfabb5"
import script from "./product-detail.vue?vue&type=script&lang=js"
export * from "./product-detail.vue?vue&type=script&lang=js"
import style0 from "./product-detail.vue?vue&type=style&index=0&id=27bfabb5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports